import getNestedProp from '@commons/utils/object/getNestedProp';
import { DOOR_NUMBER } from '../model';

function getDoorNumber(location) {
  return getNestedProp(location, DOOR_NUMBER);
}

export default getDoorNumber;
